// extracted by mini-css-extract-plugin
export default {"card":"styles_card__OjPfI","header":"styles_header__Ij9DL","close":"styles_close__c7TuP","body":"styles_body__ikXe-"};